var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.9997C9.49267 12.9997 8 11.507 8 9.66634C8 7.82567 9.49267 6.33301 11.3333 6.33301C13.1747 6.33301 14.6667 7.82567 14.6667 9.66634C14.6667 11.507 13.1747 12.9997 11.3333 12.9997",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 3.56673H14.0002",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 7.66667V2.33333C14.0002 1.59667 13.4035 1 12.6668 1H2.66683C1.93016 1 1.3335 1.59667 1.3335 2.33333V8.33333C1.3335 9.07 1.93016 9.66667 2.66683 9.66667H8.00016",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 8.72656L10.3936 10.6066",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 10.6066L10.3936 8.72656",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIconTwo);
export default __webpack_public_path__ + "static/media/timeline-icon-two.bfb7c13e4044e6bd568aa4a4fb124880.svg";
export { ForwardRef as ReactComponent };